import cashDeskInstance from './instance'

const getClientMonitorConfig = () => {
	return cashDeskInstance.get('/clientMonitorConfig')
}

export default getClientMonitorConfig
